/** URL slug helpers. Slugs are part of our SEO surface, so they are stable ids
 * in their own right — renaming a product must not silently change its URL. */
/**
 * Text reduced to its comparable form: accents folded, case dropped, `&` spelled
 * out, apostrophes elided.
 *
 * Split out of `slugify` because search needs exactly this and then wants WORDS,
 * where slugify wants a hyphenated string. Writing the same five rules twice is
 * how the two quietly stop agreeing — and then a product is findable by one of
 * its names and not the other.
 */
export function normaliseText(input) {
    return input
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/['’]/g, '');
}
export function slugify(input) {
    return normaliseText(input)
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80);
}
export function isValidSlug(slug) {
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug) && slug.length <= 80;
}
/** Appends -2, -3 … until the slug is unique within `taken`. */
export function uniqueSlug(base, taken) {
    const root = slugify(base);
    if (!taken.has(root))
        return root;
    for (let n = 2; n < 1000; n += 1) {
        const candidate = `${root}-${n}`;
        if (!taken.has(candidate))
            return candidate;
    }
    throw new Error(`uniqueSlug: exhausted suffixes for "${base}"`);
}
/** /visiting-cards/rounded-corner — category path from an ancestor chain. */
export function categoryPath(ancestorSlugs) {
    return `/${ancestorSlugs.filter(Boolean).join('/')}`;
}
export function productPath(productSlug) {
    return `/p/${productSlug}`;
}
//# sourceMappingURL=slug.js.map